module.exports = "/images/goodies.png?d79d1b7fa30057e6057ed98dad9caeb1";